/**
 * ThemeProvider component - Applies theme to the document
 * This component should wrap the app to ensure theme is applied on mount
 * Note: A blocking script in index.html sets the initial theme before React loads
 * to prevent FOUC (Flash of Unstyled Content) and loading issues in dark mode
 * 
 * The useTheme hook already handles:
 * - Applying theme to document
 * - System preference detection
 * - Listening to system preference changes
 * 
 * This component just ensures the hook is called at the app root level
 */

import {useTheme} from '../../hooks/useTheme';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({children}: ThemeProviderProps) {
  // useTheme hook handles all theme logic including:
  // - Applying theme class to document.documentElement
  // - Resolving 'system' theme to actual light/dark based on OS preference
  // - Listening to system preference changes when theme is 'system'
  // - Updating the DOM when theme or system preference changes
  useTheme();

  return <>{children}</>;
}

